import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter } from 'rxjs/operators';


@Component({
    selector: 'app-user-profile-element-wrapper',
    templateUrl: './user-profile-element-wrapper.component.html',
    styleUrls: ['./user-profile-element-wrapper.component.css'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserProfileElementWrapperComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);


  ngOnInit(): void {
  }
}
